import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Industry"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.1475 4.6125C21.9154 4.47853 21.6296 4.47853 21.3975 4.6125L15 7.785V5.25C14.9992 4.99006 14.8639 4.74905 14.6423 4.61307C14.4208 4.47709 14.1446 4.46552 13.9125 4.5825L7.5 7.785V2.25C7.5 1.83579 7.16421 1.5 6.75 1.5H2.25C1.83579 1.5 1.5 1.83579 1.5 2.25V21H22.5V5.25C22.5005 4.99087 22.3672 4.74984 22.1475 4.6125ZM16.5 19.5H13.5V14.25H16.5V19.5ZM21 19.5H18V13.5C18 13.0858 17.6642 12.75 17.25 12.75H12.75C12.3358 12.75 12 13.0858 12 13.5V19.5H3V3H6V10.215L13.5 6.465V10.215L21 6.465V19.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Industry.vue"]]);
